import ReceiptTax from 'components/receipt/commons/CountingBox/ReceiptTax'
import RefundSubTotal from 'components/receipt/commons/CountingBox/Subtotal/RefundSubTotal.js'
import Gratuity from 'components/receipt/commons/CountingBox/Gratuity'
import styles from './CountingBox.css'

class ReceiptRefundCountingBox extends React.Component {
  render () {
    let {invoiceRefund, subtotal} = this.props

    return (
      invoiceRefund.is_refund_breakdown &&
      <div className={styles['receipt-counting-box']}>
        <RefundSubTotal subtotal={subtotal} />
        {
          invoiceRefund.payment_gratuities.length > 0 &&
          <Gratuity
            gratuities={invoiceRefund.payment_gratuities}
            includeGratuityTax={invoiceRefund.include_gratuity_tax}
          />
        }
        {
          invoiceRefund.payment_taxes.length > 0 &&
          <ReceiptTax
            taxes={invoiceRefund.payment_taxes}
            includeGratuityTax={invoiceRefund.include_gratuity_tax}
          />
        }
      </div>
    )
  }
}

ReceiptRefundCountingBox.propTypes = {
  invoiceRefund: React.PropTypes.object,
  subtotal: React.PropTypes.number
}

export default ReceiptRefundCountingBox



// WEBPACK FOOTER //
// ./app/components/receipt/invoices/CountingBox/ReceiptRefundCountingBox.js